import { ReactElement } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format } from 'date-fns'

import { ShortListDocumentsProps } from './shortListDocuments.types'
import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'
import { useStore } from '../../../application/store/store'
import { useDocumentUseCase } from '../../../application/useCases/useDocuments'
import {
  ShortListWrapper,
  Title,
  Element,
  Name,
  StyledDate,
  ViewButton,
  CenterWrapper,
  StyledCategory,
  StyledTable,
} from './shortListDocuments.styles'
import { Document } from '../../../domain/documents.types'

const ShortListDocuments = (props: ShortListDocumentsProps): ReactElement | null => {
  const { documentsList, documentsLoading } = props
  const { setBlobFetching, setSingleFileDownloading } = useStore()
  const { getBlob, downloadFile } = useDocumentUseCase()
  const fetchBlob = (blobId: string): void => {
    setBlobFetching(blobId)
    getBlob(blobId)
  }
  const downloadSingleFile = (file: Document): void => {
    setSingleFileDownloading(file.sharepointId)
    downloadFile(file)
    setSingleFileDownloading(file.sharepointId)
  }
  const { t } = useCustomTranslation('common')

  const getRowsData = (): ReactElement[] => {
    return documentsList.map((document) => {
      return (
        <tr key={document.sharepointId}>
          <Element>{document.documentType.toUpperCase()}</Element>
          <Element>
            <Name>{document.displayName}</Name>
            <StyledDate>{format(new Date(document.publishedAt), 'dd/MM/yyyy')}</StyledDate>
          </Element>
          <Element>{document.powerPlantName}</Element>
          <Element>
            <StyledCategory color={document.reportType} style={{ textAlign: 'center' }}>
              {document.reportType}
            </StyledCategory>
          </Element>
          <Element>
            {document.documentType === 'pdf' && (
              <ViewButton type="button" onClick={() => fetchBlob(document.sharepointId)}>
                <FontAwesomeIcon
                  icon={document.loading ? 'spinner' : 'eye'}
                  spin={document.loading}
                />
              </ViewButton>
            )}
          </Element>
          <Element>
            <ViewButton type="button" onClick={() => downloadSingleFile(document)}>
              <FontAwesomeIcon
                icon={document.loading ? 'spinner' : 'download'}
                spin={document.loading}
              />
            </ViewButton>
          </Element>
        </tr>
      )
    })
  }
  if (documentsList.length === 0) return null
  return (
    <ShortListWrapper>
      <Title>
        <span>{t('last_documents')}</span>
      </Title>
      {documentsLoading ? (
        <CenterWrapper>
          <FontAwesomeIcon icon="spinner" spin size="lg" />
        </CenterWrapper>
      ) : (
        <StyledTable>
          <tbody>{getRowsData()}</tbody>
        </StyledTable>
      )}
    </ShortListWrapper>
  )
}

export default ShortListDocuments
